export default "__VITE_ASSET__BhH3EhM8__"